import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@els/els-react--button';
import Loader from '@Components/Loader';
import ExportTabTooltip from './Components/ExportTabTooltip';

import './ExportTab.scss';

function ExportTab(props) {
  const { exportResult, closeTab, initializeTab, tooltipModalOpened, toggleTooltipModal } = props;

  useEffect(() => {
    initializeTab();

    return () => {
      closeTab();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTooltipToggle = () => {
    toggleTooltipModal(!tooltipModalOpened);
  };

  const handleTooltipClose = () => {
    toggleTooltipModal(false);
  };

  return (
    <div className={classnames('exportTab', { 'exportTab-hidden': !exportResult })}>
      {tooltipModalOpened && <ExportTabTooltip close={handleTooltipClose} {...props} />}
      {exportResult && (
        <div className="exportTab__button">
          <Button
            data-e2e="export-tab-button"
            type="tertiary"
            size="small"
            onClick={handleTooltipToggle}
            className="u-els-display-flex e2e-export-tab-button">
            Exports
            <Loader className="u-els-margin-left-1o2 exportTab__button_loader" showText={false} progressValue={exportResult.progress} />
          </Button>
        </div>
      )}
    </div>
  );
}

ExportTab.propTypes = {
  exportResult: PropTypes.object,
  closeTab: PropTypes.func.isRequired,
  initializeTab: PropTypes.func.isRequired,
  tooltipModalOpened: PropTypes.bool,
  toggleTooltipModal: PropTypes.func.isRequired,
};

export default ExportTab;
